import type { ReactNode } from 'react';
import { Icon, type IconName } from './Icon';

export type ChipTone =
  'READY' | 'PART' | 'WAIT' | 'HOLD' | 'STARTED' | 'CANCELLED' | 'ok' | 'wait' | 'hold' | 'neutral';

const TONE_ICON: Record<ChipTone, IconName | null> = {
  READY: 'check',
  PART: 'half',
  WAIT: 'clock',
  HOLD: 'stop',
  STARTED: 'play',
  CANCELLED: 'x',
  ok: 'check',
  wait: 'half',
  hold: 'stop',
  neutral: null,
};

/** Status always carries colour + icon + word (PRD accessibility rule). */
export function Chip({
  tone,
  children,
  icon,
}: {
  tone: ChipTone;
  children: ReactNode;
  icon?: IconName | null;
}) {
  const i = icon === undefined ? TONE_ICON[tone] : icon;
  return (
    <span className={`chip chip--${tone}`}>
      {i && <Icon name={i} />}
      {children}
    </span>
  );
}

export type DotKind = 'ok' | 'part' | 'bad' | 'pend' | 'lock';

export interface GateDot {
  key: string;
  letter: string;
  kind: DotKind;
  title: string;
}

export function GateDots({ dots, small }: { dots: GateDot[]; small?: boolean }) {
  return (
    <span
      className={`gdots${small ? ' gdots--sm' : ''}`}
      role="img"
      aria-label={dots.map((d) => d.title).join(', ')}
    >
      {dots.map((d) => (
        <span key={d.key} className={`gd gd--${d.kind}`} title={d.title} aria-hidden="true">
          {d.letter}
        </span>
      ))}
    </span>
  );
}

export function Swatch({ hex }: { hex: string }) {
  return <span className="swatch" style={{ ['--sw' as string]: hex }} aria-hidden="true" />;
}
